import { useEffect, useState } from 'react';

import { customerDefaultValue, CustomerViewModel } from '@models/Customer';
import { CustomerService } from '@services/Customer';

export const useCustomerGet = () => {
  const [id, setId] = useState<number | null>(null);
  const [customer, setCustomer] =
    useState<CustomerViewModel>(customerDefaultValue);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [errorMessages, setErrorMessages] = useState<string[] | undefined>([]);

  const reset = () => {
    setCustomer(customerDefaultValue);
    setIsSuccess(false);
    setErrorMessages([]);
  };

  const loadData = async (id: number) => {
    try {
      setId(id);
      setIsLoading(true);
      reset();

      const result = await CustomerService.getById(id);

      if (result.isSuccess && 'data' in result) {
        setCustomer(result.data);
        setIsSuccess(true);
        console.log('Success: Fetched the record.');
      } else {
        console.error('Error: Failed to get record.', result.errorMessages);
        setIsSuccess(false);
        setErrorMessages(result.errorMessages);
      }
    } catch (error) {
      setErrorMessages(['An unexpected error occurred']);
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const setData = (data: CustomerViewModel) => {
    setCustomer(data);
  };

  useEffect(() => {
    if (id !== null) {
      loadData(id);
    }
  }, [id]);

  return {
    customer,
    isLoading,
    isSuccess,
    errorMessages,
    loadData,
    setData,
    reset,
  };
};
